import { keyBy } from "lodash";
import { ChatSettingsStorageType, STORAGE_CHAT_SETTINGS, STORAGE_THEME } from "../../constants/localstorage";
import { getStorage, hasStorageKey } from "../../libs/storage";
import store from "../index";
//import { setMessengerTheme } from "./actions";
import {
  ADD_CHAT_SETTINGS,
  ADD_STICKER_GROUP,
  EDIT_IS_IN_USER_LIST_STICKER_GROUP,
  MessengerActionTypes,
  MessengerStateType,
  MessengerThemeLayoutType,
  MessengerThemeType,
  SET_ATTACHMENT,
  SET_CRAPPER_VISIBILITY,
  SET_CURRENT_TABS_ASIDE,
  SET_EDIT_ID,
  SET_MESSENGER_INFO_CONFIG,
  SET_MESSENGER_PLAYER_AUDIO,
  SET_MESSENGER_THEME,
  SET_MULTI_SESSION,
  SET_SCROLL_INITIALIZED,
  SET_UPDATE_AVAILABLE,
} from "./types";
import {
  addChatSettings,
  addStickerGroup,
  editCrapperVisibility,
  editIsInUserListStickerGroup,
  setMessengerAsideTabs,
  setMessengerAttachment,
  setMessengerEditId,
  setMessengerInfoConfig,
  setMessengerPlayerAudio,
  setMessengerTheme,
  setMultiSession,
  setScrollInitialized,
  setUpdateAvailable,
} from "./actions";
import { InfoConfigResponse } from "../../proto/InfoConfig_pb";
import { createReducer } from "@reduxjs/toolkit";

window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
  store.dispatch(setMessengerTheme(e.matches ? MessengerThemeType.DARK : MessengerThemeType.LIGHT));
});

const chatSettingItems: ChatSettingsStorageType = {
  hour_24: hasStorageKey(STORAGE_CHAT_SETTINGS, "hour_24") ? getStorage(STORAGE_CHAT_SETTINGS)?.hour_24 : false,
  show_sender_name_in_groups: hasStorageKey(STORAGE_CHAT_SETTINGS, "show_sender_name_in_groups") ? getStorage(STORAGE_CHAT_SETTINGS)?.show_sender_name_in_groups : true,
  show_channel_vote_layout: hasStorageKey(STORAGE_CHAT_SETTINGS, "show_channel_vote_layout") ? getStorage(STORAGE_CHAT_SETTINGS)?.show_channel_vote_layout : true,
  send_by_enter_key: hasStorageKey(STORAGE_CHAT_SETTINGS, "send_by_enter_key") ? getStorage(STORAGE_CHAT_SETTINGS)?.send_by_enter_key : true,
  play_message_sound_in_chat: hasStorageKey(STORAGE_CHAT_SETTINGS, "play_message_sound_in_chat") ? getStorage(STORAGE_CHAT_SETTINGS)?.play_message_sound_in_chat : true,
  play_Message_Text_To_Voice: hasStorageKey(STORAGE_CHAT_SETTINGS, "play_Message_Text_To_Voice") ? getStorage(STORAGE_CHAT_SETTINGS)?.play_Message_Text_To_Voice : true,
  in_app_browser: hasStorageKey(STORAGE_CHAT_SETTINGS, "in_app_browser") ? getStorage(STORAGE_CHAT_SETTINGS)?.in_app_browser : true,
  trim_video: hasStorageKey(STORAGE_CHAT_SETTINGS, "trim_video") ? getStorage(STORAGE_CHAT_SETTINGS)?.trim_video : true,
  compress_video: hasStorageKey(STORAGE_CHAT_SETTINGS, "compress_video") ? getStorage(STORAGE_CHAT_SETTINGS)?.compress_video : true,
  open_video_with_default_player: hasStorageKey(STORAGE_CHAT_SETTINGS, "open_video_with_default_player") ? getStorage(STORAGE_CHAT_SETTINGS)?.open_video_with_default_player : true,
  crop_and_resize_photo: hasStorageKey(STORAGE_CHAT_SETTINGS, "crop_and_resize_photo") ? getStorage(STORAGE_CHAT_SETTINGS)?.crop_and_resize_photo : true,
  small_camera_in_attachments: hasStorageKey(STORAGE_CHAT_SETTINGS, "small_camera_in_attachments") ? getStorage(STORAGE_CHAT_SETTINGS)?.small_camera_in_attachments : true,
  date_item: hasStorageKey(STORAGE_CHAT_SETTINGS, "date_item") ? getStorage(STORAGE_CHAT_SETTINGS)?.date_item : "",
  chat_font_size: hasStorageKey(STORAGE_CHAT_SETTINGS, "chat_font_size") ? getStorage(STORAGE_CHAT_SETTINGS)?.chat_font_size : 14,
  theme_layout: hasStorageKey(STORAGE_CHAT_SETTINGS, "theme_layout") ? getStorage(STORAGE_CHAT_SETTINGS)?.theme_layout : MessengerThemeLayoutType.WIDE,
};
const initialState: MessengerStateType = {
  messengerAttachment: undefined,
  messengerEditId: undefined,
  playerAudioMessageId: {
    messageId: undefined,
    status: undefined,
  },
  messengerTheme: getStorage(STORAGE_THEME) ? getStorage(STORAGE_THEME) : window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ? MessengerThemeType.DARK : MessengerThemeType.LIGHT,
  messengerInfoConfig: undefined,
  stickerGroups: {},
  imageCropper: { visibility: false, dragOption: [], preview: "", isImage: false },
  chatSettings: chatSettingItems,
  asideTabs: InfoConfigResponse.Tab.CHAT,
  updateAvailable: false,
  scrollInitialized: false,
  multiSession: false,
};

export const messengerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setMessengerAttachment, (state, action) => {
      state.messengerEditId = undefined;
      state.messengerAttachment = action.payload;
    })
    .addCase(setMessengerEditId, (state, action) => {
      state.messengerAttachment = undefined;
      state.messengerEditId = action.payload;
    })
    .addCase(setMessengerPlayerAudio, (state, action) => {
      state.playerAudioMessageId = action.payload;
    })
    .addCase(setMessengerTheme, (state, action) => {
      state.messengerTheme = action.payload;
    })
    .addCase(setMessengerInfoConfig, (state, action) => {
      state.messengerInfoConfig = action.payload;
    })
    .addCase(addStickerGroup, (state, action) => {
      state.stickerGroups = {
        ...state.stickerGroups,
        ...keyBy(action.payload, "_id"),
      };
    })
    .addCase(editIsInUserListStickerGroup, (state, action) => {
      state.stickerGroups[action.payload] = {
        ...state.stickerGroups[action.payload],
        isInUserList: !state.stickerGroups[action.payload]?.isInUserList,
      };
    })
    .addCase(editCrapperVisibility, (state, action) => {
      state.imageCropper = action.payload;
    })
    .addCase(addChatSettings, (state, action) => {
      console.log("action=>", action.payload);
      state.chatSettings = { ...state.chatSettings, ...action.payload };
    })
    .addCase(setMessengerAsideTabs, (state, action) => {
      state.asideTabs = action.payload;
    })
    .addCase(setUpdateAvailable, (state, action) => {
      state.updateAvailable = action.payload;
    })
    .addCase(setScrollInitialized, (state, action) => {
      state.scrollInitialized = action.payload;
    })
    .addCase(setMultiSession, (state, action) => {
      state.multiSession = action.payload;
    });
});
